import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export function initHistory() {
    const containers = document.querySelectorAll('.js-history-swiper');
    if (!containers.length) return;

    containers.forEach(container => {
        const wrapper = container.closest('.history__wrapper');

        const slides = container.querySelectorAll('.swiper-slide');
        let initialSlide = 0;
        slides.forEach((slide, i) => {
            if (slide.classList.contains('history__item--current')) initialSlide = i;
        });

        new Swiper(container, {
            modules: [Navigation],
            initialSlide,
            spaceBetween: 0,
            watchOverflow: true,
            navigation: {
                nextEl: /** @type {HTMLElement} */ (wrapper.querySelector('.swiper-button-next')),
                prevEl: /** @type {HTMLElement} */ (wrapper.querySelector('.swiper-button-prev')),
            },
            breakpoints: {
                0: { slidesPerView: 1, centeredSlides: false },
                768: { slidesPerView: 2, centeredSlides: true },
                1250: { slidesPerView: 3 }
            },
        });
    });
}
